module.exports = __webpack_public_path__ + "static/media/01.c5311bcc.png";